module.exports = __webpack_public_path__ + "public/images/shocker.5bb0da693450edd72189f5dea44f099d.svg";